import type { IconData } from '@stacksjs/iconify-core'

export const iAccessibility: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16.336 25.949a19.43 19.43 0 0 0-9.874 16.895A19.26 19.26 0 0 0 12.14 56.55a19.26 19.26 0 0 0 13.707 5.677c9.003 0 16.754-6.106 18.85-14.849l-3.317-.795a15.92 15.92 0 0 1-15.534 12.234a15.87 15.87 0 0 1-11.296-4.679a15.87 15.87 0 0 1-4.678-11.294a16.01 16.01 0 0 1 8.139-13.924zm39.492 23.979l-3.556 1.422l-9.567-17.886H23.179l-.64-5.892l15.077.007l.001-3.411l-15.447-.006l-1.407-12.968a5.4 5.4 0 0 0 1.972.132a5.425 5.425 0 0 0 4.742-6.033a5.425 5.425 0 1 0-10.774 1.289c.052.433.158.846.303 1.237l-.038.004l2.987 27.53l.166 1.522h20.543l10.043 18.774l6.39-2.556l-1.267-3.166z\"/>",
  "width": 64,
  "height": 64,
  "viewBox": "0 0 64 64"
}

export default iAccessibility
